import React from "react";

import { Helmet } from "react-helmet";
import MainNavbar from "../MainNavbar/MainNavbar";
import { Footer } from "../Footer";

const TerminosCondiciones = () => {
    window.scrollTo(0, 0);
    return (
        <div>
            <MainNavbar />

            <div className="bg-[#0E1928] pt-32 h-72 flex">
                <p className="lg:w-2/3 md:w-4/5 w-5/6 m-auto text-2xl font-bold text-center text-white ">
                    Términos y Condiciones de la Plataforma BLUSTAY
                </p>
            </div>
            <div className="lg:w-2/3 md:w-4/5 w-5/6 mx-auto mt-10  text-[#0E1928] mb-10 lg:text-lg md:text-base text-sm text-justify">
                <p>
                    <b>BLUECORNER LLC</b>{" "}
                    <p className="italic">(y sus afiliados Blusystem S.A.C.)</p>{" "}
                    , es una plataforma que pone a disposición de sus usuarios
                    diversas herramientas para que puedan promocionar
                    comercialmente sus diversos productos.
                </p>

                <p className="mt-5">
                    En ese sentido, las condiciones, alcances y lineamientos de
                    los servicios y los términos y condiciones son los
                    siguientes:
                </p>

                <p className="mt-5 font-bold">Definiciones</p>

                <p className="mt-2">
                    <b>BLUSTAY</b> es una persona jurídica que cuenta con una
                    plataforma web integral diseñada para propietarios, agentes
                    inmobiliarios y hoteles que buscan digitalizar y optimizar
                    la gestión de sus propiedades. Ofrece páginas web
                    personalizadas con herramientas avanzadas, como sistemas de
                    reservas, CRM, estadísticas detalladas y opciones de pago
                    directo, todo en un solo lugar.
                </p>

                <p className="mt-5">
                    <b>EL CLIENTE</b> es una persona (*) que está interesada en
                    afiliarse a la plataforma web de <b>BLUSTAY</b>
                </p>

                <p className="mt-5 font-bold">Objeto</p>
                <p className="mt-2">
                    Por el presente documento, <b>EL CLIENTE</b>, contrata y,
                    por lo tanto, se suscribe a los servicios brindados por
                    <b>BLUSTAY</b>; otorgándole este último todos los permisos
                    para suscribirse a su plataforma, según las consideraciones
                    señaladas en el Anexo 1 del presente contrato.
                </p>

                <p className="mt-5 font-bold">Características</p>

                <p className="mt-2">
                    <b>EL CLIENTE</b> declara haber recibido expresamente de
                    <b>BLUSTAY</b> , y de manera previa la información sobre la
                    plataforma web <b>BLUSTAY</b>, como de sus características,
                    regulaciones, condiciones, servicios, importe y modalidades
                    de pago. Este contrato de suscripción de servicio tiene
                    condición de personal e intransferible. Será presentado
                    personalmente u remitido al correo electrónico (
                    <a
                        className="underline text-blue-500"
                        href="mailto:ventas@blustay.io"
                    >
                        ventas@blustay.io
                    </a>
                    ) señalado por EL <b>CLIENTE</b>.
                </p>

                <p className="mt-5 font-bold">Derechos de EL CLIENTE</p>

                <p className="mt-2 ml-7">
                    - <b>EL CLIENTE</b> tiene derecho a todos los servicios
                    incluidos en la plataforma BLUSTAY, según el plan de
                    suscripción adquirido, detallado en:{" "}
                    <a
                        className="underline text-blue-500"
                        href="https://blustay.io/home/6/planes"
                    >
                        https://blustay.io/home/6/planes
                    </a>
                </p>

                <p className="mt-1 ml-7">
                    - Se excluye de la suscripción cualquier derecho sobre el
                    mismo que no sean el de uso, tales como, los derechos de
                    reproducción, transformación, distribución y comunicación
                    pública. Consiguientemente, <b>EL CLIENTE</b> no podrá
                    vender, alquilar, prestar, distribuir, ceder, licenciar,
                    sublicenciar ni transferir el acceso a la plataforma{" "}
                    <b>BLUSTAY</b>
                    en modo alguno a terceros, sin la previa autorización
                    expresa y por escrito de <b>BLUSTAY</b>.
                </p>

                <p className="mt-5 font-bold">Costos</p>

                <p className="mt-2">
                    Como contraprestación por los servicios de suscripción de la
                    plataforma destacada a que se refiere la cláusula segunda
                    del presente contrato, <b>BLUSTAY</b> establecerá sus
                    tarifas de acuerdo al cuadro tarifario según cada servicio
                    contratado, detallado en:{" "}
                    <a
                        className="underline text-blue-500"
                        href="https://blustay.io/home/6/planes"
                    >
                        https://blustay.io/home/6/planes
                    </a>
                </p>

                <p className="mt-5">
                    <b>EL CLIENTE</b> se compromete a satisfacer el importe
                    total de los servicios, de acuerdo a las condiciones
                    solicitadas y pactadas en los términos y condiciones. El
                    retraso superior al periodo de suscripción en los pagos
                    pactados, supondrá la suspensión de los servicios. El
                    retraso en el pago superior a dos meses conllevará a la
                    suspensión definitiva del servicio, sin perjuicio de la no
                    exoneración de las cantidades adeudadas junto con los daños
                    y perjuicios que se hubieran podido causar hasta la fecha.
                </p>

                <p className="mt-2">
                    <b>LAS PARTES</b> acuerdan que no se devuelven pagos aunque
                    <b>EL CLIENTE</b> deje de usar el servicio contratado.
                </p>

                <p className="mt-5 font-bold">Reclamaciones</p>
                <p className="mt-2">
                    <b>EL CLIENTE</b> podrá dirigir cualquier reclamación
                    relacionada con la ejecución del servicio de suscripción
                    contratado dentro de los quince días hábiles siguientes a
                    tener conocimiento de los hechos que la motiven,
                    dirigiéndose al correo electrónico (
                    <a
                        className="underline text-blue-500"
                        href="mailto:ventas@blustay.io"
                    >
                        ventas@blustay.io
                    </a>
                    ).
                </p>

                <p className="mt-5 font-bold">
                    Terminación, suspensión o resolución de los servicios.
                </p>
                <p className="mt-2">
                    El presente acuerdo podrá ser culminado por las siguientes
                    causas:
                </p>

                <p className="mt-2 ml-7">
                    - Por mutuo acuerdo entre las partes previo al vencimiento
                    del plazo sin responsabilidad de las partes.
                </p>

                <p className="mt-1 ml-7">
                    - De manera automática por los incumplimientos de una de las
                    partes.
                </p>

                <p className="mt-5">
                    En el supuesto de que alguna de las Partes incumpla con
                    alguna de sus obligaciones establecidas en el presente
                    acuerdo, y si dicho incumplimiento no ha sido subsanado
                    entre los siguientes 30 días contados a partir de la fecha
                    de notificación escrita de dicho incumplimiento, este
                    acuerdo se considerará como terminado inmediatamente por la
                    Parte que ha cumplido sus obligaciones.
                </p>

                <p className="mt-5 font-bold">Protección de datos personales</p>
                <p className="mt-2 ml-7">
                    - <b>EL CLIENTE</b> autoriza el tratamiento y almacenamiento
                    de sus datos personales y sensibles a <b>BLUSTAY</b> ,
                    siendo este último el titular del Banco de Datos Personales.
                    Dichos datos se usarán para la prestación y comercialización
                    de servicios de <b>BLUSTAY</b> , el envío de promociones de
                    productos y servicios de terceros con quienes <b>BLUSTAY</b>{" "}
                    tenga o llegue a tener un acuerdo comercial.
                </p>
                <p className="mt-1 ml-7">
                    - <b>EL CLIENTE</b> autoriza que sus datos personales y
                    sensibles divulgados bajo el presente acuerdo sean
                    compartidos con las demás sociedades integrantes de{" "}
                    <b>BLUSTAY</b>.
                </p>
                <p className="mt-1 ml-7">
                    - Adicionalmente, <b>BLUSTAY</b> garantiza el cumplimiento
                    de la confidencialidad y el tratamiento seguro de los datos
                    de <b>EL CLIENTE</b>, para lo cual cuenta con procesos de
                    seguridad apropiados conforme a la regulación vigente, con
                    el fin de evitar la pérdida, mal uso, acceso no autorizado,
                    o robo de datos.
                </p>
                <p className="mt-1 ml-7">
                    - En caso <b>EL CLIENTE</b> necesite información adicional o
                    desee ejercer cualquiera de sus derechos establecidos en la
                    Ley N° 29733 y su Reglamento, puede contactarse con el
                    correo electrónico (
                    <a
                        className="underline text-blue-500"
                        href="mailto:ventas@blustay.io"
                    >
                        ventas@blustay.io
                    </a>
                    ) La Política de Protección de Datos Personales del BLUSTAY
                    se encuentra publicada en la página web
                    <a
                        className="text-blue-500 underline"
                        href="https://blustay.io/home/6/politicas-de-uso-y-privacidad"
                    >
                        https://blustay.io/home/6/politicas-de-uso-y-privacidad
                    </a>{" "}
                    la misma que <b>EL CLIENTE</b> E declara haber leído y
                    aceptado mediante la suscripción de este acuerdo.
                </p>

                <p className="mt-5 font-bold">DECLARACIONES DE LAS PARTES</p>
                <p className="mt-2">
                    Las partes declaran que el presente servicio de suscripción
                    fue adquirido por <b>EL CLIENTE</b> mediante la plataforma
                    de
                    <b>BLUSTAY</b> y se somete expresamente a las condiciones y
                    lineamientos establecidos en los presentes términos y
                    condiciones.
                </p>
                <p className="mt-5 font-bold">Uso ilegal o perjudicial</p>
                <p className="mt-2">
                    No usará los servicios de <b>BLUSTAY</b> en la nube para
                    guardar, mostrar, distribuir o procesar de cualquier manera
                    contenido ilegal o perjudicial.
                </p>
                <p className="mt-5">Esto incluye:</p>
                <p className="mt-1 ml-7">
                    - Actividades ilegales: promoción de sitios o servicios
                    relacionados con el juego o la pornografía infantil.
                </p>
                <p className="mt-1 ml-7">
                    - Actividades perjudiciales o fraudulentas: actividades
                    perjudiciales para otros tales como publicitar bienes,
                    servicios, esquemas y promociones fraudulentas (por ejemplo,
                    esquemas para ganar dinero fácil, esquemas Ponzi y
                    piramidales, phishing o pharming) o participar en otras
                    prácticas engañosas.
                </p>
                <p className="mt-1 ml-7">
                    - Contenido infractor: contenido que infrinja con la
                    propiedad intelectual de otros.
                </p>
                <p className="mt-1 ml-7">
                    - Contenido ofensivo: contenido difamatorio, obsceno,
                    abusivo, invasivo a la privacidad u objetable de cualquier
                    forma, incluyendo contenido que constituya pornografía
                    infantil, relacionado con la zoofilia o que muestre actos
                    sexuales no consentidos.
                </p>
                <p className="mt-1 ml-7">
                    - Contenido perjudicial: contenido malicioso y malware, como
                    virus, troyanos, gusanos, etc.
                </p>
                <p className="mt-1 ml-7">
                    - Enlaces maliciosos: enlaces que engañan a los usuarios
                    para que visiten sitios web maliciosos o peligrosos, para
                    que los visitantes afiliados hagan clic o que manipulan
                    artificialmente la reputación de otros sitios web.
                </p>
                <p className="mt-1 ml-7">
                    - Contenido spam: contenido que se publica con fines de
                    "black hat SEO" con trucos como el link building / link
                    spam, spam de palabras clave, para aprovecharse de la
                    reputación de los servicios de <b>BLUSTAY</b> para
                    promocionar contenido, bienes y servicios de terceros.
                </p>
                <p className="mt-5 font-bold">Acceso al software</p>
                <p className="mt-2">
                    <b> El Cliente</b> puede hacer uso del Software alojado en
                    la nube. La plataforma en la nube es ofrecida y administrada
                    en su totalidad por <b>BLUSTAY</b>, y <b>EL CLIENTE</b>{" "}
                    puede acceder a ella de forma remota.
                </p>
                <p className="mt-2">
                    Durante la vigencia de este acuerdo, <b>BLUSTAY</b> le
                    otorga a <b>EL CLIENTE</b> una licencia no exclusiva e
                    intransferible para usar (ejecutar, modificar, ejecutar
                    después de las modificaciones) el Software.{" "}
                    <b>EL CLIENTE</b>
                    acepta tomar todas las medidas necesarias para garantizar
                    que no se modificará la parte del Software que ejecuta y
                    verifica el uso y la recolección de estadísticas válidas,
                    incluyendo pero sin limitarse a la ejecución de una
                    instancia.
                </p>
                <p className="mt-2">
                    <b>BLUSTAY</b> se compromete a no divulgar cifras
                    individuales o mencionadas a terceros sin el consentimiento
                    de <b>EL CLIENTE</b>, y a tratar todos los datos recopilados
                    de conformidad con la Política de Privacidad.
                </p>

                <p className="mt-2">
                    Después de la expiración o terminación de este acuerdo, la
                    licencia concedida a <b>EL CLIENTE</b> será revocada
                    inmediatamente y <b>EL CLIENTE</b> acepta dejar de usar el
                    Software. En caso de que exista algún incumplimiento por
                    parte de <b>EL CLIENTE</b> a los términos de esta sección,
                    <b>EL CLIENTE</b> acuerda indemnizar a <b>BLUSTAY</b> una
                    cuota adicional equivalente al 300% del precio aplicable por
                    el Plan que está utilizando.
                </p>

                <p className="mt-5 font-bold">No solicitar o contratar</p>
                <p className="mt-2">
                    Excepto cuando <b>EL CLIENTE</b> o <b>BLUSTAY</b> de su
                    consentimiento por escrito, cada una de <b>LAS PARTES</b>,
                    sus filiales y representantes acuerdan no solicitar u
                    ofrecer empleo a ningún empleado de <b>LA OTRA PARTE</b> que
                    esté involucrado en la prestación o el uso de los Servicios
                    en virtud de este acuerdo, durante la vigencia del acuerdo y
                    por un periodo de 12 meses a partir de la fecha de
                    terminación o vencimiento de este acuerdo. En caso que
                    ocurra algún incumplimiento de las condiciones de esta
                    sección, se dará por terminado el contrato con el empleado
                    en cuestión y <b>LA PARTE</b> que ha incumplido esta
                    prohibición acuerda indemnizar a <b>LA OTRA PARTE</b> la
                    cifra de US$ 10,0000.00 dólares americanos.
                </p>
                <p className="mt-5 font-bold">Fuerza mayor</p>
                <p className="mt-2">
                    Ninguna de <b>LAS PARTES</b> será responsable ante{" "}
                    <b>LA OTRA PARTE</b> por la demora o la falta de
                    cumplimiento de sus obligaciones estipuladas en este acuerdo
                    cuando tal incumplimiento o retraso sea causado por fuerza
                    mayor, tal y como regulaciones gubernamentales, incendios,
                    huelgas, guerras, inundaciones, accidentes, epidemias,
                    embargos, apropiaciones de instalaciones o productos en su
                    totalidad o en parte por cualquier autoridad gubernamental o
                    pública, o cualquier otra causa o causas, ya sean de
                    naturaleza similares o diferentes, que están más allá del
                    control razonable de dicha parte, siempre que tal causa o
                    causas existan efectivamente.
                </p>
                <p className="mt-5 font-bold">Términos Generales de venta</p>
                <p className="mt-2">
                    Lea estos términos detenidamente antes de realizar un pedido
                    a <b>BLUSTAY</b>. Al aceptar un pedido con <b>BLUSTAY</b>,
                    <b>EL CLIENTE</b> manifiesta su aceptación de estos
                    términos.
                </p>
                <p className="mt-2">
                    <b>EL CLIENTE</b> renuncia explícitamente a sus propias
                    condiciones y términos estándar, incluso si estos se
                    redactaron después de estos términos y condiciones estándar
                    de venta. Para que una derogación sea válida, debe acordarse
                    expresamente por adelantado por escrito. En caso de falta de
                    pago en la fecha de vencimiento, <b>BLUSTAY</b> se reserva
                    el derecho de solicitar un pago de intereses fijos del 15%
                    sobre la suma pendiente. <b>BLUSTAY</b> estará autorizada a
                    suspender la prestación de servicios sin previo aviso en
                    caso de retraso en el pago. Si un pago aún está pendiente
                    más de sesenta (60) días después de la fecha de vencimiento,
                    <b>BLUSTAY</b> se reserva el derecho de recurrir a los
                    servicios de una empresa de recuperación de deudas. Todos
                    los gastos legales serán a cargo de <b>EL CLIENTE</b>. En
                    algunos países se aplica la retención en la fuente sobre el
                    monto de las facturas, de acuerdo con su legislación
                    interna. Cualquier retención en la fuente será pagada por el
                    cliente a las autoridades fiscales. En ningún caso{" "}
                    <b>BLUSTAY</b> podrá involucrarse en los costos relacionados
                    con la legislación de un país. El monto de la factura, por
                    lo tanto, será debido a <b>BLUSTAY</b> en su totalidad y no
                    incluye ningún costo relacionado con la legislación del país
                    en el que se encuentra el cliente.
                </p>

                <p className="mt-2">
                    El pago de las Suscripciones Mensuales solo puede realizarse
                    con tarjeta de crédito o un método de débito automático
                    equivalente admitido. <b>BLUSTAY</b> se reserva el derecho
                    de rechazar cualquier Suscripción Mensual que no cumpla con
                    estas condiciones.
                </p>

                <p className="mt-2">
                    <b>BLUSTAY</b> se compromete a hacer lo posible para
                    suministrar los servicios a tiempo de acuerdo con los plazos
                    acordados. Sin embargo, ninguna de sus obligaciones puede
                    considerarse como una obligación de lograr resultados.
                    BLUSTAY no puede, bajo ninguna circunstancia, ser requerida
                    por <b>EL CLIENTE</b> para aparecer como tercero en el
                    contexto de cualquier reclamación por daños presentados
                    contra <b>EL CLIENTE</b> por un consumidor final.
                </p>
            </div>
            <Footer />
        </div>
    );
};

export default TerminosCondiciones;
